import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import ExerciseLoadTypesPage from "./ExerciseLoadTypesPage";
import ExerciseLoadTypeCreatePage from "./ExerciseLoadTypeCreatePage";
import ExerciseLoadTypeEditPage from "./ExerciseLoadTypeEditPage";
 

export default (
  <Route path="exercise-load-types">
    <Route
      index
      element={
        <Protected
          path="/admin/exercise-load-types"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ExerciseLoadTypesPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/exercise-load-types/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ExerciseLoadTypeCreatePage />
        </Protected>
      }
    />
    
    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/exercise-load-types/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ExerciseLoadTypeEditPage />
        </Protected>
      }
    /> 
  </Route>
);
